import React, { useState } from 'react';
import { CheckIcon, CurrencyDollarIcon, ChartBarIcon } from '@heroicons/react/24/outline';
import UserTypeToggle from '../common/UserTypeToggle';
import RevenueCalculator from '../calculators/RevenueCalculator';
import GifComponent from './GifComponent';

const HeroSection = ({ userType, onUserTypeChange, onGetStarted, stats }) => {
  const screenOwnerContent = {
    title: (
      <>
        Turn Your Screen Into{' '}
        <span className="text-primary">₹5000+</span>{' '}
        Monthly Income
      </>
    ),
    description: "Transform any idle screen into a profitable advertising asset. Join 100+ screen owners earning passive income with zero effort required.",
    primaryButton: "Start Earning Today",
    secondaryButton: "See Earnings Calculator"
  };

  const advertiserContent = {
    title: (
      <>
        Advertise Where Your{' '}
        <span className="text-primary">Customers</span>{' '}
        Actually Look
      </>
    ),
    description: "Reach your target audience through strategically placed digital displays. Get 3x better ROI than traditional advertising with real-time analytics.",
    primaryButton: "Launch Campaign",
    secondaryButton: "View ROI Calculator"
  };

  const currentContent = userType === 'screen-owner' ? screenOwnerContent : advertiserContent;

  const trustIndicators = userType === 'screen-owner' ? [
    { icon: CheckIcon, text: `${stats.activeScreens.toLocaleString()} Active Screens` },
    { icon: CurrencyDollarIcon, text: `${stats.revenue} Revenue Generated` },
    { icon: CheckIcon, text: "SSL Secured" }
  ] : [
    { icon: CheckIcon, text: `${stats.cities} Cities Covered` },
    { icon: ChartBarIcon, text: `${stats.impressions} Monthly Impressions` },
    { icon: ChartBarIcon, text: "3x Better ROI" }
  ];

  return (
    <section className="relative bg-gradient-to-br from-surface to-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative">
        <UserTypeToggle userType={userType} onUserTypeChange={onUserTypeChange} />

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
              {currentContent.title}
            </h1>
            <p className="text-xl text-text-secondary mb-8 leading-relaxed">
              {currentContent.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button 
                className="btn-primary text-lg px-8 py-4"
                onClick={() => onGetStarted(userType)}
              >
                {currentContent.primaryButton}
              </button>
              <button 
                className="border-2 border-primary text-primary font-semibold px-8 py-4 rounded-lg hover:bg-primary hover:text-white transition-all duration-250"
                onClick={() => document.getElementById('bnfts').scrollIntoView({ behavior: 'smooth' })}
              >
                {currentContent.secondaryButton}
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-sm text-text-secondary">
              {trustIndicators.map((indicator, index) => (
                <div key={index} className="flex items-center">
                  <indicator.icon className="w-5 h-5 text-success mr-2" />
                  <span>{indicator.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-white rounded-2xl shadow-card p-8">
              <GifComponent 
  onError={(e) => {
    e.target.src = 'https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
  }} 
/>
              <div className="mt-6 grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary">₹8470</div>
                  <div className="text-sm text-text-secondary">Avg Monthly</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary">24/7</div>
                  <div className="text-sm text-text-secondary">Automated</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary">98%</div>
                  <div className="text-sm text-text-secondary">Uptime</div>
                </div>
              </div>
            </div>
            <div className="absolute -top-4 -right-4 bg-success text-white px-4 py-2 rounded-full text-sm font-semibold animate-pulse">
              +₹1270 earned today
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default HeroSection;